import { hasAnalyticsConsent } from './analytics/consent';
import { trackEvent } from './analytics/gtag';
import { EVENTS } from './analytics/events';

const reportWebVitals = (onPerfEntry) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      const forwardMetric = (metric) => {
        onPerfEntry(metric);

        if (!hasAnalyticsConsent()) {
          return;
        }

        trackEvent(EVENTS.WEB_VITAL, {
          metric_name: metric.name,
          metric_value: metric.value,
          metric_delta: metric.delta,
          metric_id: metric.id,
        });
      };

      getCLS(forwardMetric);
      getFID(forwardMetric);
      getFCP(forwardMetric);
      getLCP(forwardMetric);
      getTTFB(forwardMetric);
    });
  }
};

export default reportWebVitals;
